<template>
  <div class="activity-detail common-bg">
    <van-nav-bar fixed :title="activityData.title || '活动详情'" left-arrow :right-text="showApplyRecord ? (template === '2' || template === '5' ? '领取记录' : '申请记录') : ''" @click-left="handleBack" @click-right="showApplyRecord && $router.push((template === '2' || template === '5') ? { path: '/activity', query: { tab: '7' } } : '/activityRecord')" />
    <div style="height: 46px"></div>

    <!-- template=1 -->
    <template1 v-if="template === '1'" :activityData="activityData" :from="from" />

    <!-- template=2 -->
    <template2 v-if="template === '2'" :activityData="activityData" :from="from" />

    <!-- template=3 -->
    <template3 v-if="template === '3'" :activityData="activityData" :from="from" />

    <!-- template=4 -->
    <template4 v-if="template === '4'" :activityData="activityData" :from="from" />

    <!-- template=5 -->
    <template5 v-if="template === '5'" :activityData="activityData" :from="from" />

    <!-- template=6 -->
    <template6 v-if="template === '6'" :activityData="activityData" :from="from" />
  </div>
</template>

<script>
import template1 from './activityDetail/template1.vue';
import template2 from './activityDetail/template2.vue';
import template3 from './activityDetail/template3.vue';
import template4 from './activityDetail/template4.vue';
import template5 from './activityDetail/template5.vue';
import template6 from './activityDetail/template6.vue';
import { recommendList } from './activityDetail/activityConfig';

export default {
  name: 'activityDetail',
  components: {
    template1,
    template2,
    template3,
    template4,
    template5,
    template6,
  },
  data() {
    return {
      activity_id: '',
      template: '',
      from: '',
      activityData: {},
    };
  },
  created() {
    this.loadFromRoute();
  },
  watch: {
    '$route.query': {
      handler() {
        this.loadFromRoute();
      },
    },
  },
  methods: {
    loadFromRoute() {
      const query = this.$route.query;
      this.activity_id = query.activity_id || '';
      this.template = query.template || '';
      this.from = query.from || '';
      if (this.activity_id) {
        this.fetchActivityDetail();
      }
    },
    handleBack() {
      if (this.from === 'home') {
        this.$router.replace('/').catch(() => {});
      } else if (this.from === 'activity') {
        this.$router.replace('/activity').catch(() => {});
      } else {
        this.$router.back().catch(() => {});
      }
    },
    fetchActivityDetail() {
      // 模拟数据，后续替换为API接口
      const titleMap = {
        '1': '活动申请入口',
        '72': '8月感恩回馈盛典 百亿钜惠火热策划中！',
        '2': '新会员奖赏一',
        '3': '新会员奖赏二',
        '4': '新会员奖赏三',
        '5': '新会员奖赏四',
        '6': '新会员奖赏五',
        '7': '新会员奖赏六',
        '8': '2026美加墨世界杯官方指定投注网站：6556.com',
        '9': '欢乐集字 瓜分大礼',
        '10': '狂欢世界杯 竞猜赢大奖',
        '11': '畅玩指定游戏 打码冲刺',
        '12': '2026美加墨世界杯官方指定投注网站：6556.com',
        '13': '基础体育知识',
        '14': '神秘彩金一笔存款奖金翻倍 赢率飙升',
        '15': '我司正式引入风靡全球线下赌场的[龙之连环]系列游戏',
        '16': 'WG电子-龙之连环 每日投注加赠',
        '17': 'WG电子-龙之连环 幸运注单',
        '18': 'WG电子-龙之连环 每周投注加赠',
        '19': 'WG电子 每周盈亏皆有礼',
        '20': '携手共进 合作共赢',
        '21': '钱包SVIP',
        '22': '钱包教程 手把手教学',
        '23': '提现转充值',
        '24': '虚拟币钱包激活礼金',
        '25': 'NO/USDT首次使用赠送6%',
        '26': 'NO钱包/USDT：存款有礼',
        '27': '虚拟币钱包笔笔返现1%-3.5%无上限',
        '28': 'No钱包：担保与理赔',
        '29': '官方推荐：No内置钱包',
        '30': '充值折扣 震撼来袭',
        '31': '邀请每人 即领150元',
        '32': '午夜狂欢 激情派对',
        '33': '重金寻老友 豪礼一：VIP专属等级礼~最高46888元',
        '34': '重金寻老友 豪礼二：回归存款即送',
        '35': '重金寻老友 豪礼三：亏损转运金',
        '36': '逢8必发',
        '37': '天天存 天天送',
        '38': '激情七天乐',
        '39': 'APP趣抢红包--神秘幸运彩金',
        '40': 'VIP优越会',
        '41': '实时返水 高达3.5%',
        '42': '天天签到 天天金喜',
        '43': '2026年第七期现金回馈',
        '44': '关注站内信 神秘彩金 不期而遇',
        '45': 'WG电子 全网独家首创',
        '46': '分享-发现 爆奖瞬间金喜每一刻',
        '47': '云股东福利',
        '48': '推荐晋升奖励',
        '49': '全民云股东模式',
        '50': 'PG电子投注加赠',
        '51': 'PG电子消消乐 开心连消领彩金',
        '52': 'PG电子 官方直营',
        '53': '电子游艺 笔笔转运金',
        '54': '公积金',
        '55': '祝君生日快乐',
        '56': '玩赚渔乐圈',
        '57': '每日决战 转运金助您反败为胜',
        '58': '捕鱼周周投注彩金',
        '59': '棋牌对战 局局连赢',
        '60': '棋牌竞技 扭转乾坤',
        '61': '棋牌周周投注彩金',
        '62': '真人每日大闯关',
        '63': '真人幸运注单',
        '64': '真人百家乐连赢',
        '65': '真人周周投注彩金',
        '66': '畅玩区块链 每日打码奖励',
        '67': '区块链转运金 助您一臂之力',
        '68': '区块链周周投注彩金',
        '69': '王者之路 挑战极限',
        '14': '神秘彩金一笔存款奖金翻倍 赢率飙升',
        '70': '官方邮箱 咨询网址',
        '71': '澳门新蒲京集团',
      };
      // 根据 template 选择不同的数据格式
      if (this.template === '3') {
        this.activityData = {
          id: this.activity_id,
          title: titleMap[this.activity_id] || '活动详情',
          banner: '/static/image/event/ActiveImg22759981117937708_00001.avif',
          content: '热门活动一站式申请：世界杯、综合、热门、新人类类等多项热门活动。点击"跳转"即可快速进入申请页面，方便快捷，不错过任何福利！',
          comprehensiveTitle: '综合优惠',
          comprehensive: [
            { title: '综合优惠', items: [['天天存 天天送', ''], ['午夜狂欢 激情派对', ''], ['逢8必发', ''], ['每月现金回馈', ''], ['天天签到 天天金喜', ''], ['激情七天乐', ''], ['生日礼金', ''], ['APP抢红包', '']] },
            { title: '新人优惠', items: [['首存即送 8888元', ''], ['首投奖励 最高8888元', ''], ['新人二送 彩金送不停', ''], ['注册3/7/15天 在领5888元', ''], ['新人三送 最高领8888元', '']] },
            { title: '钱包优惠', items: [['钱包SVIP礼金', ''], ['NO钱包/USDT 首存赠送6%', ''], ['虚拟币钱包 激活礼金', ''], ['NO钱包/USDT 每日存款加赠', '']] },
            { title: '云股东优惠', items: [['邀请一人 领150元', ''], ['全民最高佣金 0投资 高回报', ''], ['每月工资 抽成高达3%', ''], ['线下升级领8888元', '']] },
            { title: '电子优惠', items: [['PG电子 每日投注领8888元', ''], ['PG电子 连消领100倍彩金', ''], ['电子笔笔救援金', '']] },
            { title: '捕鱼/棋牌/真人/区块链优惠', items: [['捕鱼每日闯关', ''], ['棋牌连赢 无限嘉奖15%', ''], ['捕鱼每日亏损运金', ''], ['棋牌每日亏损 助理高达5%', ''], ['捕鱼每周投注加赠', ''], ['棋牌每周投注加赠', ''], ['真人每日闯关', ''], ['区块链每日闯关', ''], ['真人幸运注单', ''], ['区块链每日亏损运金', ''], ['真人连赢大挑战', ''], ['区块链每周投注加赠', ''], ['真人每周投注加赠', '']] },
          ],
          note: '',
          receiveMethod: '',
          memo: [
            '1.会员活动相关数据均由系统自动统计，若有任何异议，以澳门新蒲京集团系统统计结果为准；',
            '2.如您忘记会员账号，密码，请您联系7*24小时在线客服协助您取回您的账号信息；',
            '3.参与该优惠，即表示您同意《优惠规则与条款》。',
          ],
        };
      } else if (this.template === '4') {
        this.activityData = {
          id: this.activity_id,
          title: titleMap[this.activity_id] || '澳门新蒲京集团',
          banner: '/static/image/event/ActiveImg22759981117937708_00001.avif',
          content: '',
          receiveMethod: '',
          memo: [
            '1.会员活动相关数据均由系统自动统计，若有任何异议，以澳门新蒲京集团系统统计结果为准；',
            '2.如您忘记会员账号，密码，请您联系7*24小时在线客服协助您取回您的账号信息；',
            '3.参与该优惠，即表示您同意《优惠规则与条款》。',
          ],
        };
      } else if (this.template === '5') {
        this.activityData = {
          id: this.activity_id,
          title: titleMap[this.activity_id] || '新会员奖赏',
          banner: '/static/image/event/ActiveImg22759981117937708_00001.avif',
          content: '',
          receiveMethod: '',
          conditions: [
            '1.需要完成如下所有任务：收款方式绑定'
          ],
          notice: [
            '1.账号首次充值专享，只有一次机会，充值越多，奖励越多，最高奖励8,888.00',
            '2.任意方式充值都可获得奖励，充值成功后，可前往活动详情或者待领取页面进行查看，若未查看到奖励，可尝试点击刷新或等待几分钟后再试',
            '3.获得的奖励 实时领取，仅限在 PC、Android_H5、iOS_H5、Android_APP、iOS_APP 端手动领取',
            '4.每个周期结束后1天奖励过期，若未领取则直接作废',
            '5.本活动所赠送的奖金（不含本金）需1.00倍有效投注才能提现，投注不限游戏平台'
          ],
          terms: [
            '1.本活动仅限新注册会员参与，每位会员仅限参与一次',
            '2.所有奖金需完成1倍流水方可提款',
            '3.本平台保留对本次活动的最终解释权',
            '4.如发现违规行为，将取消获奖资格并冻结账户',
            '5.如遇问题请联系24小时在线客服',
          ],
          memo: [],
        };
      } else if (this.template === '6') {
        this.activityData = {
          id: this.activity_id,
          title: titleMap[this.activity_id] || '活动详情',
          banner: '/static/image/event/ActiveImg22759981117937708_00001.avif',
          content: '<strong>活动时间：</strong>即日起（北京时间）<br/><strong>活动内容：</strong>所有会员使用【手机APP】每日登录即有机会领取神秘彩金，彩金随机获取翻倍，高率直接飙升！',
          special1Title: 'APP登录礼',
          special1: {
            columns: ['指定任务', '参与条件', '奖项'],
            rows: [
              ['所有会员使用\n【手机APP】', '每日登录\n即有机会\n领取神秘彩金', '彩金随机\n获取翻倍\n高率直接飙升'],
            ],
            note: '注:【澳门新蒲京集团489vipcn.com】会员福利每日惊喜放送，最高8888元奖金等您来拿!所有会员均可参与，奖品随机抽取，祝您旗开得胜!',
          },
          special1Img: '/static/newImg/active/template/template6_01.avif',
          receiveMethod: '',
          conditions: '',
          memo: [
            '1.本活动所赠送的彩金（不含本金）需1倍流水（即稽核、打码或有效投注）才能提现，打码不限游戏平台；',
            '2.本活动禁止不同账号对赌、互刷、套利、利用漏洞、群控或其他非法手段参与，否则将取消活动资格；',
            '3.会员活动相关数据均由系统自动统计，若有任何异议，以澳门新蒲京集团系统统计结果为准；',
            '4.如您忘记会员账号，密码，请您联系7*24小时在线客服协助您取回您的账号信息；',
            '5.参与该优惠，即表示您同意《优惠规则与条款》。',
          ],
        };
      } else {
        this.activityData = {
          id: this.activity_id,
          title: titleMap[this.activity_id] || '活动详情',
          banner: '/static/image/event/ActiveImg22759981117937708_00001.avif',
          content: '<strong>活动时间：</strong>即日起（北京时间）<br/><strong>活动内容：</strong>【澳门新蒲京集团489vipcn.com】新注册会员完成首存后在注册7天内使用【NO/USDT及所有虚拟币钱包】支付方式进行充值完成第二次存款并畅玩任意游戏有效投注三倍流水，即可获得最高3888元二存加赠彩金，一倍流水即可提款~快快告知您的好友一起来参与吧！',
          special1Title: '逢2会员日特惠一',
          special1: {
            columns: ['活动对象', '二存金额', '投注要求', '可获彩金', '提款要求'],
            rows: [
              ['澳门新蒲京集团\n新注册会员\n注册7天内\n使用\n【NO/USDT及所有虚拟币钱包】\n支付方式\n完成\n第二次存款', '200+', '任务游戏\n三倍流水', '16元', '一倍流水\n即可提款'],
              ['', '500+', '', '26元', ''],
              ['', '1000+', '', '46元', ''],
              ['', '2000+', '', '68元', ''],
              ['', '5000+', '', '188元', ''],
              ['', '1万元+', '', '288元', ''],
              ['', '2万元+', '', '468元', ''],
              ['', '5万元+', '', '888元', ''],
              ['', '10万元+', '', '1888元', ''],
              ['', '20万元+', '', '2888元', ''],
              ['', '30万元+', '', '3888元', ''],
            ],
            note: '',
          },
          receiveMethod: '登录会员账号☞点击活动下方☞【优惠申请】自助提交申请。',
          conditions: '新注册会员需完成绑定虚拟币钱包和实名认证。',
          memo: [
            '1.本活动所赠送的彩金（不含本金）需1倍流水（即稽核、打码或有效投注）才能提现，打码不限游戏平台；',
            '2.仅限新注册会员于注册7天内参与，逾期视为自愿放弃参与该活动；',
            '3.本活动禁止不同账号对赌、互刷、套利、利用漏洞、群控或其他非法手段参与，否则将取消活动资格；',
            '4.会员活动相关数据均由系统自动统计，若有任何异议，以澳门新蒲京集团系统统计结果为准；',
            '5.如您忘记会员账号，密码，请您联系7*24小时在线客服协助您取回您的账号信息；',
            '6.参与该优惠，即表示您同意《优惠规则与条款》。',
          ],
        };
      }
    },
  },
  computed: {
    showApplyRecord() {
      const id = String(this.activity_id);
      const item = recommendList.find(r => r.activityId === id);
      return item ? item.apply_show === 1 : false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../static/css/common.css';

.activity-detail {
  min-height: 100vh;
}
</style>

<style>
.van-nav-bar__text {
  color: #dfb372;
  font-size: 0.3rem;
}

.van-nav-bar .van-nav-bar__title {
  white-space: normal !important;
  line-height: 1.4 !important;
  max-width: 55% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/activityDetail.vue